function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h22v22H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round",
  mask: "url(#b)",
  d: "M9 9v9M13 9v9"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  stroke: "#9B9B9B",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M3 6l2 15h12l2-15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 5h20M14 4a3 3 0 10-6 0"
})));

function SvgDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.347e2b5e.svg";
export { ForwardRef as ReactComponent };